import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { API } from "@/lib/auth";
import { BrandMark } from "@/lib/branding";
import { SoTraceView } from "@/components/trace/SoTraceView";

// PUBLIC READ-ONLY izlenebilirlik (QR). Login/menü/yönetim linki YOK; auth interceptor'larından bağımsız fetch.
export default function PublicTracePage() {
  const { token } = useParams();
  const [sp] = useSearchParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    const s = sp.get("s");
    fetch(`${API}/public/trace/${encodeURIComponent(token)}${s ? `?s=${encodeURIComponent(s)}` : ""}`, { credentials: "omit" })
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then(setData)
      .catch(() => setErr(true));
  }, [token, sp]);
  return (
    <div className="min-h-screen bg-slate-50" data-testid="public-trace-page">
      <header className="bg-white border-b px-4 py-3 flex items-center gap-3">
        <BrandMark className="h-10 w-24" testId="public-trace-logo" />
        <div className="text-sm font-semibold text-slate-700">İzlenebilirlik</div>
      </header>
      <main className="max-w-4xl mx-auto p-4">
        {err && <div className="mt-16 text-center text-slate-600 text-lg" data-testid="public-trace-not-found">İzlenebilirlik kaydı bulunamadı.</div>}
        {!err && !data && <div className="mt-16 text-center text-slate-400 text-sm">Yükleniyor…</div>}
        {data && <SoTraceView data={data} photoUrl={(pid) => `${API}/public/trace/${encodeURIComponent(token)}/photos/${pid}`} />}
      </main>
    </div>
  );
}
